import { render, staticRenderFns } from "./myMarks.vue?vue&type=template&id=269ff177&scoped=true"
import script from "./myMarks.vue?vue&type=script&lang=js"
export * from "./myMarks.vue?vue&type=script&lang=js"
import style0 from "./myMarks.vue?vue&type=style&index=0&id=269ff177&prod&lang=scss"
import style1 from "./myMarks.vue?vue&type=style&index=1&id=269ff177&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269ff177",
  null
  
)

export default component.exports